import PageLayout from "@/components/feature/PageLayout";
import BackToTop from "@/components/feature/BackToTop";
import Hero from "./components/Hero";
import HotList from "./components/HotList";
import CategoryNav from "./components/CategoryNav";
import LatestArticles from "./components/LatestArticles";
import StatsBand from "./components/StatsBand";
import BrandSection from "./components/BrandSection";
import FaqSection from "./components/FaqSection";
import CtaBanner from "./components/CtaBanner";

export default function Home() {
  return (
    <PageLayout>
      <Hero />
      <HotList />
      <CategoryNav />
      <LatestArticles />
      <StatsBand />
      <BrandSection />
      <FaqSection />
      <CtaBanner />
      <BackToTop />
    </PageLayout>
  );
}